import React from 'react'
import LineSeparatorWithText from './line-separator-with-text'

function OrLineSeparator() {
    return (
        <LineSeparatorWithText 
            text='or'
        />
    )
}

export default OrLineSeparator